module.exports = __webpack_public_path__ + "media/images/slider_bg-febcbe9cfd4afb21ee55417e7873edb6.png";